import TCSegmentUIModel from './tc-segment';

class TCSegmentsCollectionUIModel {
  constructor(segments = []) {
    this.segments = segments.map(segment => {
      return new TCSegmentUIModel(segment);
    });
  }
}

export default TCSegmentsCollectionUIModel;